import axios from "axios";
import { fetchNewToken } from "./environment.dev";

// Create axios instance
const instance = axios.create();

instance.interceptors.response.use(
  response => {
    return response;
  },
  async (error) => {
    const prevRequest = error?.config;
    if ((error?.response?.status === 403 || error?.response?.status === 400) && !prevRequest?.sent) {
      prevRequest.sent = true;

      return interceptor(`${fetchNewToken}`, {
        method: "GET",
        timeout: 50000,
      }).then((response) => {
        sessionStorage.setItem("ags_token", response.data.access_token);
        sessionStorage.setItem("refresh", response.data.refresh_token);
        sessionStorage.setItem(
          "user_info",
          response.data.first_name + " " + response.data.last_name
        );
        sessionStorage.setItem("user_role", response.data.role);
        
        prevRequest.headers['Authorization'] = sessionStorage.getItem("ags_token");
        return instance(prevRequest);
      }).catch((error) => {
        window.open('login', "_self");
      });
    }
    return Promise.reject(error);
  }
);

export const interceptor = async (url, options) => {
  let sessionToken = sessionStorage.getItem("ags_token") || "";
  let refresh = sessionStorage.getItem("refresh") || "";
  
  const controller = new AbortController();
  const timeout = options?.timeout || 12000;
  
  // Set up timeout with better error handling
  const timeoutId = setTimeout(() => {
    controller.abort();
  }, timeout);
  
  const wrapperOptions = {
    ...options,
    headers: {
      ...options?.headers, 
      Authorization: `${sessionToken}`, 
      refresh: refresh
    },
    signal: controller.signal,
  };

  try {    
    const response = await instance({
      data: options?.body,
      url,
      method: options?.method || 'GET',
      responseType: options?.responseType === 'blob' ? 'blob' : 'json',
      headers: wrapperOptions.headers,
      signal: controller.signal
    });
    
    // Clear timeout on successful response
    clearTimeout(timeoutId);
    
    // Handle tenant group
    const tenant_group = response.headers['x-tenant-group'] || response.headers['X-Tenant-Group'];
    if (tenant_group) {
      sessionStorage.setItem("tenant_group", tenant_group);
    }
    
    return response;
    
  } catch (error) {
    clearTimeout(timeoutId);
      
    // Handle different types of errors
    if (error.name === 'AbortError' || error.code === 'ECONNABORTED') {
      // Timeout error
      const timeoutError = new Error(`Request timeout after ${timeout}ms`);
      timeoutError.code = 'TIMEOUT';
      timeoutError.isTimeout = true;
      throw timeoutError;
    }
    
    // Re-throw the original error for other cases
    throw error;
  }
};
